"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.shouldApplyGuardianSignature = exports.requiresGuardianSignature = exports.guardTransactions = exports.fetchGuardianData = exports.chainIdToEnv = void 0;
const types_1 = require("@elrond-giants/erdjs-auth/dist/types");
const network_1 = require("./network");
const signature_1 = require("@multiversx/sdk-core/out/signature");
const chainIdToEnv = (chainId) => {
    if (chainId === "1") {
        return "mainnet";
    }
    if (chainId === "T") {
        return "testnet";
    }
    return "devnet";
};
exports.chainIdToEnv = chainIdToEnv;
const fetchGuardianData = (address, chainId) => __awaiter(void 0, void 0, void 0, function* () {
    const env = (0, exports.chainIdToEnv)(chainId);
    const gatewayUrl = network_1.network[env].gateway;
    try {
        const response = yield fetch(`${gatewayUrl}/address/${address}/guardian-data`);
        return yield response.json();
    }
    catch (e) {
        return null;
    }
});
exports.fetchGuardianData = fetchGuardianData;
const guardTransactions = (transactions, code, env) => __awaiter(void 0, void 0, void 0, function* () {
    const url = `${network_1.network[env].tools}/guardian/sign-multiple-transactions`;
    const body = {
        code,
        transactions: transactions.map(tx => tx.toSendable())
    };
    const response = yield fetch(url, {
        method: "POST",
        body: JSON.stringify(body),
    });
    const result = yield response.json();
    const signatures = result.data.transactions.map((t) => t.guardianSignature);
    return transactions.map((tx, i) => {
        tx.applyGuardianSignature(new signature_1.Signature(signatures[i]));
        return tx;
    });
});
exports.guardTransactions = guardTransactions;
const requiresGuardianSignature = (tx) => {
    return tx.getOptions().isWithGuardian()
        && tx.getGuardian().bech32().length > 0
        && tx.getGuardianSignature().length === 0;
};
exports.requiresGuardianSignature = requiresGuardianSignature;
const shouldApplyGuardianSignature = (providerType) => {
    // Some providers will sign the transaction with the guardian signature
    // automatically, so we don't need to do it.
    // For the ones listed below, we need to apply the guardian signature.
    return [
        types_1.AuthProviderType.LEDGER,
        types_1.AuthProviderType.PEM,
        types_1.AuthProviderType.WALLET_CONNECT,
    ].includes(providerType);
};
exports.shouldApplyGuardianSignature = shouldApplyGuardianSignature;
